import { Container } from "react-bootstrap";
import fullDiaBanner from "../../assets/img/inner-banner/Full-Diamond-Grading-Reports.webp";
import fullDiaBannerMobile from "../../assets/img/mobile-banner/Full-Diamond-Grading-Reports.webp";

import fancydiamond from "../../assets/img/Icons-Certificate/Fancy-Diamond.jpg";
import identification from "../../assets/img/Icons-Certificate/Jewelry-Identification.jpg";
import report from "../../assets/img/Icons-Certificate/Lab-Grown-Reports.jpg";
import "./Certificatedetail.css";
import { Link } from "react-router-dom";
import {
  MdKeyboardDoubleArrowRight,
  MdOutlineKeyboardDoubleArrowRight,
} from "react-icons/md";
import { Helmet } from "react-helmet";

export default function FullDiamondGradingReports() {
  return (
    <>
      <Helmet>
        {/* Meta tags */}
        <title>Full Diamond Grading Report | Sreehari Diamond Report </title>
        <meta
          name="description"
          content="Get a complete diamond grading report detailing cut, color, clarity, and carat weight. Trusted by buyers and sellers for accurate diamond evaluation"
        />
        <meta
          name="keywords"
          content="lab grown diamond certification, best diamond certification in india, Gemstone Identification Lab, Diamond, Gemological Laboratory, Diamond Testing Lab, Diamond Sealing service, Diamond Hologram Stickers, Hologram Stickers for Certificates, Best diamond online services, 4 cs' of diamonds, 4cs education of diamond"
        />
        {/* OG tags */}
        <meta
          property="og:title"
          content="Full Diamond Grading Report | Sreehari Diamond Report"
        />
        <meta
          property="og:description"
          content="Get a complete diamond grading report detailing cut, color, clarity, and carat weight. Trusted by buyers and sellers for accurate diamond evaluation"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://sreeharidiamondlab.com/full-diamond-grading-reports"
        />
        <meta
          property="og:image"
          content="https://sreeharidiamondlab.com/static/media/logo.04f6bad90dcf8391f785.png
"
        />
        <meta property="og:site_name" content="sreehari diamond laboratory" />
        {/* Twitter tags */}
        <meta
          name="twitter:title"
          content="Full Diamond Grading Report | Sreehari Diamond Report"
        />
        <meta
          name="twitter:description"
          content="Get a complete diamond grading report detailing cut, color, clarity, and carat weight. Trusted by buyers and sellers for accurate diamond evaluation"
        />
        <meta
          name="twitter:image"
          content="https://sreeharidiamondlab.com/static/media/logo.04f6bad90dcf8391f785.png
"
        />
        <meta name="twitter:site" content="sreehari diamond laboratory" />
        <link
          rel="canonical"
          href="https://sreeharidiamondlab.com/full-diamond-grading-reports"
        />{" "}
      </Helmet>
      <section>
        <Container fluid className="bannersection position-relative p-0">
          <img
            src={window.innerWidth > 568 ? fullDiaBanner : fullDiaBannerMobile}
            alt="Service banner"
            className="w-100  h-100 object-fit-cover about-banner-img"
          />
          <h2>Where light meets legacy</h2>

          <div className="textoverlay pt-5 d-flex flex-column justify-content-center align-items-center position-absolute top-0 w-100 h-100 text-center"></div>
        </Container>
      </section>
      <section className="hologram-section section-spacing-x section-spacing-y pb-0">
        <div className="container-fluid">
          <div className="row">
            <h1 className="heading mb-3 text-center">
              Full Diamond Grading Reports{" "}
            </h1>
          </div>
          <p className="mb-1">
            These reports include an assessment of the 4Cs of the diamond,
            measurements and other important parameters of the diamond, and a
            Fluorescence picture of the diamond is optional. Thus, providing you
            with complete security and peace of mind.
          </p>
          <p className="mb-1">
            Classified into two categories: One is certified that a single
            diamond or the no of diamonds has been securely placed on a
            specialized rubber sheet, which is pasted to the certificate of
            authenticity. The entire assembly has been carefully sealed to
            ensure the protection, security, and traceability of that diamond.
            This provides a verifiable link between the diamond and its
            certificate.
          </p>
          <p className="mb-1">
            And on the other is, to certify that the loose diamond has been
            carefully placed within a secure presentation box featuring a
            transparent top for clear visibility. The box is sealed properly to
            ensure product integrity and tamper evidence.
          </p>
          <p className="mb-1">
            The diamond and its original certificate of authenticity, enclosed
            in the same package. The transparent design allows for immediate
            visual inspection of both the diamond and its certificate, while
            maintaining the security and traceability of the contents.
          </p>
          <p>
            And also ensures that the diamond remains protected during handling,
            transit, and storage. Also the certificate remains physically linked
            to the corresponding diamonds. This allows the buyer and seller to
            have peace of mind.
          </p>

          <div className="contact-us-button mt-lg-4 mb-lg-3 mb-4">
            <Link to="/contact-us">
              Contact Us <MdOutlineKeyboardDoubleArrowRight />
            </Link>
          </div>
        </div>
      </section>

      <section className="section-spacing-x">
        <div className="container-fluid">
          <div className="row mb-5">
            <h2 className="text-center mb-4 heading">Other Certificates</h2>

            <div className="col-lg-4 mb-lg-0 mb-3">
              <div className="service-card text-center border rounded">
                <div className="service-image mx-auto">
                  <img
                    src={identification}
                    alt="Jewelry Identification Report | Sreehari Diamond Laboratory"
                    className="img-fluid"
                  />
                </div>
                <Link to="/diamond-jewelry-reports">
                  <h3 className="mb-0">Diamond Jewelry Reports</h3>
                </Link>
                <p className="mb-3">
                  We offer detailed jewelry identification reports that
                  accurately describe the materials, diamonds, gemstones, and
                  craftsmanship, helping you authenticate and appraise your
                  valuable jewelry pieces.{" "}
                </p>
                <div className="service-read-more mt-lg-0 mt-2">
                  <Link to="/diamond-jewelry-reports">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4  mb-lg-0 mb-3">
              <div className="service-card text-center border rounded">
                <div className="service-image mx-auto">
                  <img
                    src={fancydiamond}
                    alt="Fancy Diamond Report | Sreehari Diamond Laboratory"
                    className="img-fluid"
                  />
                </div>
                <Link to="/fancy-diamond-reports">
                  <h3 className="mb-0">Fancy Diamond Reports</h3>
                </Link>
                <p className="mb-3">
                  Our Diamond reports specialize in grading unique colored
                  diamonds, detailing hue, tone, saturation, and quality to
                  certify the beauty and rarity of your fancy gemstones.{" "}
                </p>
                <div className="service-read-more mt-lg-0 mt-2">
                  <Link to="/fancy-diamond-reports">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="service-card text-center border rounded p-2">
                <div className="service-image mx-auto">
                  <img
                    src={report}
                    alt="Lab Grown Report |Sreehari Diamond Laboratory"
                    className="img-fluid"
                  />
                </div>
                <Link to="/lab-grown-reports">
                  <h3 className="mb-0">Lab Grown Reports</h3>
                </Link>
                <p className="mb-3">
                  Get reliable lab-grown diamond reports that verify
                  authenticity, quality, and characteristics, ensuring
                  transparency and confidence when buying or selling synthetic
                  diamonds.{" "}
                </p>
                <div className="service-read-more mt-lg-0 mt-2">
                  <Link to="/lab-grown-reports">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
